import { useState, useEffect } from 'react';
import { navLinks } from '@/mocks/homeData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md border-b border-primary-500/25 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <nav className="w-full px-4 md:px-6 flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-3 group">
          <div className="w-10 h-10 rounded-full overflow-hidden ring-1 ring-primary-500/50 bg-background-50 logo-glow">
            <img
              src="https://static.readdy.ai/image/7b095d95fe974d6d04490d0833e89a3e/f74a46007c2be116dc4d23be74f0eb02.png"
              alt="Bertie's Restaurant & Cocktails logo"
              className="w-full h-full object-cover"
            />
          </div>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm font-medium text-foreground-100 hover:text-primary-500 transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#reservation"
            className="whitespace-nowrap text-sm font-semibold px-5 py-2.5 rounded-full text-background-950 bg-primary-500 hover:bg-primary-400 transition-colors cursor-pointer"
          >
            Reserve a Table
          </a>
        </div>

        <button
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden flex flex-col items-center justify-center w-10 h-10 gap-1.5 border border-primary-500/40 rounded-full"
        >
          <span className={`block w-5 h-px bg-foreground-50 transition-all duration-300 ${open ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-5 h-px bg-foreground-50 transition-all duration-300 ${open ? 'opacity-0' : 'opacity-100'}`} />
          <span className={`block w-5 h-px bg-foreground-50 transition-all duration-300 ${open ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-100/95 backdrop-blur-md border-t border-primary-500/25">
          <div className="flex flex-col gap-1 px-4 py-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-3 px-3 text-sm text-foreground-100 hover:text-primary-500 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#reservation"
              onClick={() => setOpen(false)}
              className="mt-2 text-center text-sm font-semibold px-5 py-3 rounded-full text-background-950 bg-primary-500 hover:bg-primary-400 transition-colors"
            >
              Reserve a Table
            </a>
          </div>
        </div>
      )}
    </header>
  );
}